import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { FuncionariosProvider } from "./context/FuncionariosContext";
import { FuncionariosFormacaoProvider } from "./context/FuncionariosFormacaoContext";
import { SiadapProvider } from "./context/SiadapContext";
import { AuthProvider } from "./context/AuthContext";
import { AppSettingsProvider } from "./context/AppSettingsContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ActiveMunicipioProvider } from "./context/ActiveMunicipioContext";
import { FormacaoProvider } from "./context/FormacaoContext";
import { ErrorBoundary } from "./components/feature/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <AppSettingsProvider>
            <ThemeProvider>
              <ActiveMunicipioProvider>
                <FuncionariosProvider>
                  <SiadapProvider>
                    <FuncionariosFormacaoProvider>
                      <FormacaoProvider>
                        <BrowserRouter basename={__BASE_PATH__}>
                          <AppRoutes />
                        </BrowserRouter>
                      </FormacaoProvider>
                    </FuncionariosFormacaoProvider>
                  </SiadapProvider>
                </FuncionariosProvider>
              </ActiveMunicipioProvider>
            </ThemeProvider>
          </AppSettingsProvider>
        </AuthProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
